import { States } from "..";

export function getEvdaFranceAgeFilterState(states:States){
   return states.filter.EvdaFranceAge
}

export function getEvdaEuropeAgeFilterState(states:States){
    return states.filter.EvdaEuropeAge
 }

export function getEvdaFranceGenderFilterState(states:States){
    return states.filter.EvdaFranceGender
}

export function getEvdaEuropeGenderFilterState(states:States){
    return states.filter.EvdaEuropeGender
}

export function getEvdaFranceDateFilterState(states:States){
    return states.filter.EvdaFranceDate
}


export function getEvdaDepartmentsAgeFilterState(states:States){
    return states.filter.EvdaDepartmentsAge
 }
 
 export function getEvdaDepartmentsGenderFilterState(states:States){
     return states.filter.EvdaDepartmentsGender
 }
 
 export function getEvdaDepartmentsDateFilterState(states:States){
     return states.filter.EvdaDepartmentsDate
 }

 export function getEvdaDepartmentsRegionFilterState(states:States){
    return states.filter.EvdaDepartmentsRegions
}

export function getFilterModal(states: States) {
  return states.filter.filterModal;
}

export function getAreaFilterState(states:States){
    return states.filter.Area
}

export function getEvdaEuropeCountriesFilterState(states:States){
    return states.filter.EvdaEuropeCountries
}
export function getEvdaEuropeDateFilterState(states:States){
    return states.filter.EvdaEuropeDate
}

export const getEvmcLivingAgeFilterState = (states: States) =>
  states.filter.EvmcLivingAge;
export const getEvmcLivingLivingFilterState = (states: States) =>
  states.filter.EvmcLivingLiving;
export const getEvmcEducationAgeFilterState = (states: States) =>
  states.filter.EvmcEducationAge;
export const getEvmcEducationEducationFilterState = (
  states: States
) => states.filter.EvmcEducationEducation;
export const getEvmcCategoryAgeFilterState = (states: States) =>
  states.filter.EvmcCategoryAge;
export const getEvmcCategorySocialCategoryFilterState = (
  states: States
) => states.filter.EvmcCategorySocialCategory;
